/** css */
import './GanttMassiveResponsable.css';
import GanttMassiveResponsable from './GanttMassiveResponsable';

export default GanttMassiveResponsable;
